import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectSelector } from '../../../redux/slices/select'
import InfoIconBlockNoRoutes from '../../reusable/Info/Blocks/InfoIconBlockNoRoutes'
import NoRouteIcon from './NoRouteIcon'

const NoRoute = () => {
  const { loading, routes } = useSelector(selectSelector)

  return (
    <>
      {!loading && routes.length === 0 ? (
        <InfoIconBlockNoRoutes />
      ) : (
        <div className="no_route_block">
          <NoRouteIcon className="no_route_icon" />
          <Typography className="no_route_title">
            Оберіть транспорт та маршрут, щоб дізнатися більше
          </Typography>
        </div>
      )}
    </>
  )
}

export default NoRoute
